<template>
    <div class="st-container"  :style="{ width:attributes.width+'em', right:rightpos+'em' }">
        <div class="st-handle" :style="{ backgroundColor:attributes.bgcolor, borderRightColor:attributes.bgcolor }" @click="toggleTab"><q-icon :name="attributes.handleLabel" style="color:#07f;"/></div>
        <div class="st-panel"  :style="{ backgroundColor:attributes.bgcolor }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
/* TODOs
    [ ] responsive: container cannot be larger than the screen (or we won't be able to close it!)
    [ ] pass props
    [ ] feature : enable to modify the default width
    [ ] feature : enable tabs either at left or right
*/
export default {
    name: "SlidingTab",
    props: ['attributes'],
    /*
        attributes = {
            bgcolor     : valid color
            handleLabel : string
            handleTop   : number (expressed in 'em', but without the trailing 'em' string)
            width       : number (expressed in 'em', but without the trailing 'em' string)
            }
    */
    data(){
        return {
            tab: {
                // bgcolor: "antiquewhite",
                // width: 30,
                isOpen: false,
            }
        }
    },
    methods: {
        toggleTab(){
            this.tab.isOpen = !this.tab.isOpen;
        },
    },
    computed: {
        rightpos: function(){
            if (this.tab.isOpen){
                return 0;
            }
            else{
                return -(this.attributes.width - 2);
            }
        },
    },
}
</script>

<style >
.st-container {
    position   : absolute;
    top        : 0;
    bottom     : 0;
    padding    : 0;
    overflow   : hidden;
    height     : 100%;
    transition : .3s all ease-in-out;
}
.st-handle {
    display                  : inline-block;
    position                 : relative;
    width                    : 2em;
    border-top-left-radius   : 6px;
    border-bottom-left-radius: 6px;
    height                   : 2em;
    top                      : 3em;
    left                     : 0;
    border                   : 1px solid black;
    border-right             : 1px solid antiquewhite;
    font-weight              : bold;
    padding-left             : .5em;
    padding-top              : .2em;
    z-index                  : 1;
    cursor                   : pointer;
}
.st-panel {
    display     : inline-block;
    position    : absolute;
    overflow    : auto;
    border-left : 1px solid black;
    height      : 100%;
    padding     : .5em;
    margin-left : calc(2em - 1px);
    left        : 0;
}
</style>
